export class StringUtils {
  public static isNumeric(text: string): boolean {
    return !isNaN(+text);
  }
}
